
export const initialState = {
    items: [
        {modelNumber: '', unitPrice: '', quantity: '', discount: '', unitCost: '', doNotOrder: false, lockup: false},
    ],
    total: 0,
    notes: '',
    rates: '',
    salesTax: 0.00,
    deliveryFee: 10.00,
    deliveryCost: 0.00,
    deliveryFeeOverride: false,
    haulAway: false,
    haulAwayFee: 0,
    haulAwayCost: 0,
    haulAwayQuantity: 1,
    invoiceNumber: Math.floor(Math.random() * 100000),
    status: '',
    type: 'Invoice',
    creator: '',
}
